export interface IElementValidityState {
    valid: boolean;
    element: HTMLInputElement;
    message?: string;
}

export default class ElementValidityState implements IElementValidityState {
    public valid: boolean;
    public element: HTMLInputElement;
    public message?: string;

    constructor(valid: boolean, element: HTMLInputElement, message?: string) {
        this.valid = valid;
        this.element = element;
        this.message = message;
    }
}
